import React from 'react'
import { useInView } from 'react-intersection-observer'

import Slider from '../slider'
import Image from '../image'

const SliderMedias = ({data, isOffer = false}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  let checkIfAllMedias = true
  const chapo = (data.chapo) ? (data.chapo.chapo) ? data.chapo.chapo : data.chapo : null

  data.items.forEach(item => {
    const alt = item.fields ? item.fields.altImage : item.altImage

    if(alt === undefined) {
      checkIfAllMedias = false
    }
  })

  return (
    <div ref={ref} className={inView ? 'has-anim' : ''}>
      { (data.title || chapo) &&
        <div className="row mb-6 md:mb-10 scroll-anim-el">
          <div className={`col-12 ${isOffer ? 'lg-col-7' : 'lg-col-8'} mx-auto`}>
            { data.title &&
              <h2 className={`title title-slice ${ chapo ? 'mb-3 md:mb-6' : '' }`}>{data.title}</h2>
            }

            { chapo &&
              <p className="paragraph">{chapo}</p>
            }
          </div>
        </div>
      }
      <div className={`row scroll-anim-el ${data.title || chapo ? 'scroll-anim-el--2' : ''}`}>
        <div className={`col-12 ${isOffer ? 'lg-col-9' : 'lg-col-10' } mx-auto`}>
          <div className="slider-medias">
              { checkIfAllMedias ?
              <Slider nbItems={data.items.length} options = '{}' name="medias" className='slider-medias__wrap slider-centered' navCentered={true} hasPagination={true}>
                { data.items.map((item, i) => { 
                  let legend = (item.fields) ? item.fields.legend : (item.legend) ? item.legend.legend : null

                  return(
                    <div key={i}>
                      <Image
                        classes="w-full"
                        width="1280"
                        height="560"
                        sizes={{"415": [367, 250], "767": [719, 490], "1023": [963, 421] }}
                        image={item} />

                      { legend &&
                        <div className="row">
                          <div className="col-12 lg-col-8 mx-auto">
                            <p className="paragraph paragraph--small mt-14 md:mt-5">{legend}</p>
                          </div>
                        </div>
                      }
                    </div>
                  )
                }) }
              </Slider>
              : 'Slider - Format de données incorrect. Il faut uniquement des images si le type médias est sélectionné.'}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SliderMedias